import {logAPI } from "./andyliticsApi";
import * as tools from '../helpers/Tools';



const functionsKey = typeof window !== 'undefined' ? window.serverData.data.mybswhealthbfffunctionskey : '';


export const downLoadEstimate = (token, url) => {
    //const start = new Date();
    const params = {
        method: "GET",
        headers: {
            "Accept": "application/json",
            "Content-type": "application/json",
            "Authorization": "bearer " + token
        },
        mode: 'no-cors'
    }

    return fetch(url, params).then(response => {
        if (response.status >= 200 && response.status < 300) {
            return response.blob();
        } else {
            return new Blob();//response;
        }
    }).catch(err => {
        logAPI("Api.Pricing.Appointments.Get.Failure", start, url, err);
        return err;
    });

}
export const getAppointments = (token, patientId, includeProxy) => {
    const incProx = includeProxy ? `&includeProxy=${includeProxy}` : '';
    const url = tools.buildUrl(window.serverData.data.pricingAPIURL, `/UsersQuote/Appointments?patientIds=${patientId}${incProx}`);
    

    const params = {
        method: "GET",
        headers: {
            "Accept": "application/json",
            "Content-type": "application/json",
            "x-functions-key": functionsKey,
            "Authorization": "bearer " + token
        },
        mode: 'no-cors'
    };
    var start = new Date();
    return fetch(url, params).then(response => {
        logAPI("Api.Pricing.Appointments.Get", start, url);
       if (response.status >= 200 && response.status < 300) {
            return response.json();
        } else {
            return [];
        }
    }).catch(err => {
        logAPI("Api.Pricing.Appointments.Get.Failure", start, url, err);
        return err;
    });
}

export const getBenefitDetails = (token, patientId, csnId) => {
    const cid = csnId ? `&csnId=${csnId}`:'';
    //debugger;
    const url = tools.buildUrl(window.serverData.data.pricingAPIURL, `/UsersQuote/BenefitDetails?patientId=${patientId}${cid}`);

    const params = {
        method: "GET",
        headers: {
            "Accept": "application/json",
            "Content-type": "application/json",
            "x-functions-key": functionsKey,
            "Authorization": "bearer " + token
        },
        mode: 'no-cors'
    };
    var start = new Date();

    return fetch(url, params).then(response => {
        logAPI("Api.Pricing.BenefitDetails.Get", start, url,null,"start");
        if (response.status >= 200 && response.status < 300) {
            logAPI("Api.Pricing.BenefitDetails.Get", new Date(), url, null, "complete",`status '${response.status}'`);
            return response.json();
        } else {
            logAPI("Api.Pricing.BenefitDetails.Get", new Date(), url, null, "complete with error", `status '${response.status}'`);
            return response;
        }
    }).catch(err => {
        logAPI("Api.Pricing.BenefitDetails.Get.Failure", start, url, err);
        return err;
    });
};